require('./polyfills/class_list');
require('./polyfills/object_assign');
require('./polyfills/object_entries');
require('./polyfills/object_foreach');
